import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import {
  UserPlusIcon,
  PencilIcon,
  TrashIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import {
  Dialog,
  Card,
  CardHeader,
  Input,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Chip,
  Typography,
  Button,
  Badge,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
  Select,
  Option,
  Textarea,
} from "@material-tailwind/react";
import {
  createQuestionnaireData,
  createVendorData,
  editVendorData,
  getQuestionnaireData,
  getVendorData,
  deleteVendorAPI,
  getUserData,
  deleteQuestionnaireAPI,
  assignQuestionnaireToVendor,
  sendEmailToVendor,
  createVendorThroughExcelUpload,
} from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import toast from "react-hot-toast";
import LoadingButton from "../../components/Loaders/LoadingButton";
import AlertBox from "./AlertBox";
import ExcelJS from "exceljs";
import VendorListQues from "./VendorListQues";
import TableRowWithShowMore from "../../components/TableRowWithShowMore";
import QuestionnaireListVendor from "./QuestionnaireListVendor";
import { Link, useNavigate } from "react-router-dom";
import CreateVendorQuestionnaireList from "./CreateVendorQuestionnaireList";

export default function VendorManagement() {
  const { refreshToken, rbac } = useAuthUserToken();
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState([]);
  const [quesTemplateData, setQuesTemplateData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [reviewer, setReviewer] = useState([]);
  const [vendorIsLoading, setVendorIsLoading] = useState(null);
  const [isLoadingSelect, setIsLoadingSelect] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [status, setStatus] = useState("");
  const [compliantStatus, setCompliantStatus] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({ name: "" });
  const [id, setId] = useState("");
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isLoadingButtonForExcel, setIsLoadingButtonForExcel] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openCreateDialogQues, setOpenCreateDialogQues] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteDataId, setDeleteDataId] = useState("");
  const [openQuestionModal, setOpenQuestionModal] = useState(false);
  const [dropDownVendorData, setDropDownVendorData] = useState([]);
  const [questionnaireList, setQuestionnaireList] = useState([]);
  const [defaultQuestionnaireList, setDefaultQuestionnaireList] = useState([]);
  const [vendorIdList, setVendorIdList] = useState([]);
  const [activeTab, setActiveTab] = useState("vendors");
  const [sendEmailLoading, setSendEmailLoading] = useState({});
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadForm, setUploadForm] = useState({ file: null });
  const [excelData, setExcelData] = useState([]);
  const [excelError, setExcelError] = useState([]);
  const [excelLogEnteries, setExcelLogEnteries] = useState([]);
  const [openVendorListDialogQues, setOpenVendorListDialogQues] =
    useState(false);
  const [tableHead, setTableHead] = useState([
    "Name",
    "Type",
    "Status",
    "Compliance",
    "Questionnaire",
    "Email",
    "Action",
  ]);

  const requiredFields = [
    "vendorLegalName",
    "vendorType",
    "vendorContactName",
    "vendorContactEmail",
    "vendorRegisteredAddress",
    "vendorContactPhone",
    "vendorStatus",
    "vendorOnboardingTimestamp",
    "vendorOffboardingTimestamp",
    "reviewer",
    "questionnaireObj",
  ];

  const initialQuestionnaireCreateFormData = {
    compliance: "",
    quesName: "",
    file: null,
    quesList: [],
  };

  const initialVendorFormData = {
    quesId: "",
    quesName: "",
    quesList: [],
  };

  const [quesFormData, setQuesFormData] = useState(
    initialQuestionnaireCreateFormData
  );

  const [assignVendorList, setAssignVendorList] = useState(
    initialVendorFormData
  );

  const data = [
    {
      label: "Vendors",
      value: "vendors",
    },
    {
      label: "Questionnaire",
      value: "questionnaire",
    },
  ];

  const handleQuestionList = (item) => {
    setAssignVendorList({
      quesId: item?.id || "",
      quesName: item?.quesName || "",
      quesList: item?.quesList || [],
    });
    setOpenQuestionModal((cur) => !cur);
  };

  const handleVendorList = (item) => {
    setIsLoadingSelect(null);
    setAssignVendorList({
      quesId: item?.id || "",
      quesName: item?.quesName || "",
      quesList: item?.quesList || [],
    });
    getVendorData(refreshToken, "", "", 1000).then((data) => {
      setDropDownVendorData(data?.data?.results);
      setIsLoadingSelect(false);
    });
    setOpenVendorListDialogQues((cur) => !cur);
  };

  const handleChangeVendorList = (selectedOptions) => {
    const selectedIds = selectedOptions.map((option) => option?.id);
    setVendorIdList(selectedIds);
  };

  const handleOpenCreateDialog = () => {
    setStep(1);
    setFormData(formSetData);
    setIsLoadingButton(false);
    setOpenCreateDialog((cur) => !cur);
  };

  const handleDeleteDialog = (id) => {
    setDeleteDataId(id);
    setDeleteDialog((cur) => !cur);
  };

  const handleOpenCreateDialogQues = () => {
    setOpenCreateDialogQues((cur) => !cur);
  };

  const handleNext = () => {
    validateForm();
    if (step !== 3 && Object.keys(errors).length === 0) {
      setStep((prevValue) => prevValue + 1);
    }
  };

  const dateSet = (vendorDataDate) => {
    if (vendorDataDate) {
      const date = new Date(vendorDataDate);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    }
  };

  const handlePrev = () => {
    if (step !== 0) setStep((prevValue) => prevValue - 1);
  };

  const handleOpen = (item) => {
    const vendorOnboardingTimestamp = dateSet(item?.vendorOnboardingTimestamp);
    const vendorOffboardingTimestamp = dateSet(
      item?.vendorOffboardingTimestamp
    );
    setFormData({
      vendorLegalName: item?.vendorLegalName || "",
      vendorType: item?.vendorType || "",
      vendorStatus: item?.vendorStatus || "",
      vendorContactName: item?.vendorContactName || "",
      vendorContactEmail: item?.vendorContactEmail || "",
      vendorRegisteredAddress: item?.vendorRegisteredAddress || "",
      vendorContactPhone: item?.vendorContactPhone || "",
      vendorOnboardingTimestamp: vendorOnboardingTimestamp || "",
      vendorOffboardingTimestamp: vendorOffboardingTimestamp || "",
      reviewer: item?.reviewer || "",
      questionnaire: [],
    });
    setDefaultQuestionnaireList(item?.questionnaire);
    setId(item?.id || "");
    setErrors({ name: "" });
    setOpen((cur) => !cur);
  };

  const handleOpenUploadDialog = () => {
    setOpenUploadDialog((cur) => !cur);
    setExcelData([]);
    setExcelError([]);
    setExcelLogEnteries([]);
    setUploadForm({ file: null });
  };

  const validateUploadVendorList = () => {
    const newErrors = {};
    if (!uploadForm.file) {
      newErrors.file = "File is required";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0 && excelError.length === 0) {
      setIsLoadingButtonForExcel(true);
    }
  };

  //validation for excel upload
  const validateFields = (data) => {
    const newExcelErrors = [];
    const validatedData = data.map((item, index) => {
      const validatedItem = { ...item };
      // Check for required fields
      requiredFields.forEach((field) => {
        if (!validatedItem[field] || validatedItem[field] === "") {
          console.error(
            `Row ${index + 1
            }: Field "${field}" is missing or empty in Excel file.`
          );
          newExcelErrors.push(
            `Row ${index + 1
            }: Field "${field}" is missing or empty in Excel file.`
          );
          validatedItem[field] = null;
        }
      });

      if (
        validatedItem["questionnaireObj"] &&
        typeof validatedItem["questionnaireObj"] === "string"
      ) {
        validatedItem["questionnaireObj"] = validatedItem["questionnaireObj"]
          .split(",")
          .map((q) => q.trim());
      }

      const parseExcelDate = (excelDate) => {
        return new Date(Math.round((excelDate - 25569) * 86400 * 1000));
      };

      if (validatedItem["vendorOnboardingTimestamp"]) {
        validatedItem["vendorOnboardingTimestamp"] = parseExcelDate(
          validatedItem["vendorOnboardingTimestamp"]
        );
      }
      if (validatedItem["vendorOffboardingTimestamp"]) {
        validatedItem["vendorOffboardingTimestamp"] = parseExcelDate(
          validatedItem["vendorOffboardingTimestamp"]
        );
      }

      return validatedItem;
    });

    setExcelError(newExcelErrors);
    return validatedData;
  };

  const handleVendorFileUpload = async (event) => {
    const newErrors = {};
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        const validatedData = validateFields(jsonData);
        setExcelData(validatedData);
        setUploadForm({
          file: selectedFile,
        });
        newErrors.file = "";
      };
      reader.readAsArrayBuffer(selectedFile);
    } else {
      newErrors.file = "File is required";
    }
    setErrors(newErrors);
  };

  useEffect(() => {
    if (
      Object.keys(errors).length === 0 &&
      excelError.length === 0 &&
      isLoadingButtonForExcel
    ) {
      submitVendorList();
    }
  }, [errors, excelError, isLoadingButtonForExcel]);

  const handleUploadVendorListSubmit = (e) => {
    e.preventDefault();
    validateUploadVendorList();
  };

  const handleEditCancel = () => {
    setStep(1);
    setOpen((cur) => !cur);
  };

  useEffect(() => {
    if (activeTab === "vendors") {
      setIsLoading(null);
      setTableHead([
        "Name",
        "Type",
        "Status",
        "Compliance",
        "Questionnaire",
        "Email",
        "Action",
      ]);
      getVendorData(
        refreshToken,
        searchBy,
        sortBy,
        limit,
        page,
        status,
        compliantStatus
      ).then((data) => {
        if (data?.code === 403) {
          navigate('/403');
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        }
        if (data?.code === 440)
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        setTotalPage(data?.data?.totalPages);
        setTemplateData(data?.data?.results);
        setIsLoading(false);
      });
    } else if (activeTab === "questionnaire") {
      setIsLoading(null);
      setTableHead(["Name", "Assign", "Action"]);
      getQuestionnaireData(
        refreshToken,
        searchBy,
        sortBy,
        limit,
        page,
        status
      ).then((data) => {
        if (data?.code === 403) {
          navigate('/403');
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        }
        if (data?.code === 440)
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        setTotalPage(data?.data?.totalPages);
        setQuesTemplateData(data?.data?.results);
        setIsLoading(false);
      });
    }
  }, [
    page,
    limit,
    sortBy,
    searchBy,
    status,
    activeTab,
    reloadData,
    compliantStatus,
  ]);

  const handleDelete = async (id) => {
    setIsLoadingButton(true);
    if (activeTab === "vendors") {
      deleteVendorAPI(refreshToken, id)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("Vendor Data deleted successfully", {
              className: "text-[12px]",
            });
          } else if (response.code === 400) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setIsLoading(null);
          setIsLoadingButton(false);
          setDeleteDataId("");
          setReloadData((cur) => !cur);
          setDeleteDialog((cur) => !cur);
        });
    } else if (activeTab === "questionnaire") {
      deleteQuestionnaireAPI(refreshToken, id)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("Questionnaire Data deleted successfully", {
              className: "text-[12px]",
            });
          } else if (response.code === 400) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setIsLoading(null);
          setIsLoadingButton(false);
          setDeleteDataId("");
          setReloadData((cur) => !cur);
          setDeleteDialog((cur) => !cur);
        });
    }
  };

  // Create Form Functionality
  const formSetData = {
    vendorLegalName: "",
    vendorType: "",
    vendorContactName: "",
    vendorContactEmail: "",
    vendorRegisteredAddress: "",
    vendorContactPhone: "",
    vendorStatus: "",
    vendorOnboardingTimestamp: "",
    vendorOffboardingTimestamp: "",
    reviewer: "",
    questionnaire: [],
  };

  const [formData, setFormData] = useState(formSetData);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      questionnaire: [],
    }));
    if (step === 2) {
      getQuestionnaireData(
        refreshToken,
        searchBy,
        sortBy,
        limit,
        page,
        status
      ).then((data) => {
        setQuestionnaireList(data?.data?.results);
        setVendorIsLoading(false);
      });
      getUserData(refreshToken, searchBy, sortBy, limit, page, status).then(
        (data) => {
          setReviewer(data?.data?.results);
        }
      );
    }
  }, [step]);

  const handleChangeStep2 = (selectedOptions) => {
    if (selectedOptions.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        questionnaire: selectedOptions.map((option) => ({
          questionnaireId: option?.id,
          status: "assigned",
        })),
      }));
    }
  };

  const handleEditChangeStep2 = (selectedOptions) => {
    if (selectedOptions.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        questionnaire: [
          ...selectedOptions.map((option) => ({
            questionnaireId: option?.id,
            status: "assigned",
          })),
        ],
      }));
    }
  };

  const handleChangeSelect = (e, fieldName) => {
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    if (activeTab === "vendors") {
      setFormData((prevData) => ({
        ...prevData,
        [fieldName]: e,
      }));
    } else {
      setQuesFormData((prevData) => ({
        ...prevData,
        [fieldName]: e,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    if (activeTab === "vendors") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setQuesFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
    if (activeTab === "vendors") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setQuesFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleBlur = () => {
    validateForm();
  };

  const handleQuestionChange = (event, index) => {
    const { value } = event.target;
    const updatedQuestions = [...quesFormData.quesList];
    updatedQuestions[index] = { ...updatedQuestions[index], question: value };
    setQuesFormData({ ...quesFormData, quesList: updatedQuestions });
    validateForm();
  };

  const handleFileUpload = (event) => {
    const newErrors = { ...errors };
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setQuesFormData({
        ...quesFormData,
        file: selectedFile,
      });
      newErrors.file = "";
    } else {
      newErrors.file = "File is required";
    }
    setErrors(newErrors);
  };

  const handleDeleteQuestion = (index) => {
    if (quesFormData.quesList.length === 1) {
      setAlertMessage("Questions cannot be completely deleted.");
      return;
    }
    if (quesFormData.quesList.length === 1) {
      setAlertMessage("Questions cannot be completely deleted.");
      return;
    }
    const updatedQuestions = [...quesFormData.quesList];
    updatedQuestions.splice(index, 1);
    setQuesFormData({ ...quesFormData, quesList: updatedQuestions });
    validateForm();
  };

  const handleAddQuestion = () => {
    setQuesFormData({
      ...quesFormData,
      quesList: [...quesFormData.quesList, ""],
    });
    validateForm();
  };

  const validateForm = () => {
    const newErrors = {};
    if (activeTab === "vendors") {
      if (!formData.vendorLegalName.trim())
        newErrors.vendorLegalName = "Legal Name is required";
      if (!formData.vendorType.trim())
        newErrors.vendorType = "Type is required";
      if (!formData.vendorContactName.trim())
        newErrors.vendorContactName = "Contact Person Name is required";
      if (!formData.vendorContactEmail.trim())
        newErrors.vendorContactEmail = "Contact Person Email is required";
      if (!formData.vendorContactPhone.trim())
        newErrors.vendorContactPhone = "Contact Person Phone is required";
      if (!formData.vendorRegisteredAddress.trim())
        newErrors.vendorRegisteredAddress = "Registered Address is required";
      if (!formData.vendorStatus.trim())
        newErrors.vendorStatus = "Status is required";
      if (!formData.vendorOnboardingTimestamp.trim())
        newErrors.vendorOnboardingTimestamp = "Onboarding Date is required";
      if (
        Date.parse(formData.vendorOnboardingTimestamp) >=
        Date.parse(formData.vendorOffboardingTimestamp)
      ) {
        newErrors.vendorOffboardingTimestamp =
          "Offboarding date not be less than or equal to Onboarding Date";
      }
      if (step === 2) {
        if (
          !formData.reviewer ||
          typeof formData.reviewer !== "string" ||
          !formData.reviewer.trim()
        ) {
          newErrors.reviewer = "Reviewer is required";
        }
      }
    } else if (activeTab === "questionnaire") {
      if (!quesFormData.compliance.trim())
        newErrors.compliance = "Compliance standard is required";
      if (!quesFormData.quesName.trim())
        newErrors.quesName = "Name is required";
      if (!quesFormData.file) newErrors.file = "File is required";
      if (quesFormData.quesList.length === 0)
        newErrors.quesList = "At least one question is required";
      const quesListErrors = [];
      quesFormData?.quesList.forEach((question, index) => {
        if (question && question?.question && !question.question.trim()) {
          quesListErrors.push(index + 1);
        }
      });

      if (quesListErrors.length > 0) {
        const errorMessages = quesListErrors
          .map((index) => `Question ${index}`)
          .join(", ");
        newErrors.quesList = `${errorMessages} is/are required`;
      }
    }
    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    validateForm();
    if (Object.keys(errors).length === 0) {
      setIsLoadingButton(true);
      if (activeTab === "vendors") {
        createVendorData(refreshToken, formData)
          .then((response) => {
            if (response?.code === 200 || response?.code === 201) {
              toast.success("Vendor Data created successfully", {
                className: "text-[12px]",
              });
            } else if (response.code === 400) {
              toast.error(response?.message, {
                className: "text-[12px]",
              });
            } else {
              toast.error(response?.message, {
                className: "text-[12px]",
              });
            }
          })
          .catch((error) => {
            toast.error("Something went wrong!", {
              className: "text-[12px]",
            });
            console.error("Error during login:", error);
          })
          .finally(() => {
            setIsLoadingButton(false);
            setStep(1);
            setReloadData((cur) => !cur);
            setFormData(formSetData);
            setOpenCreateDialog((cur) => !cur);
          });
      } else {
        let formDataFinal = new FormData();
        quesFormData.quesList.forEach((questionObject, index) => {
          const questionKey = `quesList[${index}][question]`;
          const questionValue = questionObject.question;
          formDataFinal.append(questionKey, questionValue);
        });
        formDataFinal.append("compliance", quesFormData?.compliance);
        formDataFinal.append("quesName", quesFormData?.quesName);
        formDataFinal.append("file", quesFormData?.file);

        createQuestionnaireData(refreshToken, formDataFinal)
          .then((response) => {
            if (response?.code === 200 || response?.code === 201) {
              toast.success("Questionnaire Data created successfully", {
                className: "text-[12px]",
              });
            } else if (response.code === 400) {
              toast.error(response?.message, {
                className: "text-[12px]",
              });
            } else {
              toast.error(response?.message, {
                className: "text-[12px]",
              });
            }
          })
          .catch((error) => {
            toast.error("Something went wrong!", {
              className: "text-[12px]",
            });
            console.error("Error during login:", error);
          })
          .finally(() => {
            setQuesFormData(quesFormData);
            setIsLoadingButton(false);
            setOpenCreateDialogQues((cur) => !cur);
            setReloadData((cur) => !cur);
          });
      }
    }
  };

  const handleVendorEdit = async (e) => {
    e.preventDefault();
    validateForm();
    if (Object.keys(errors).length === 0) {
      setIsLoadingButton(true);
      if (activeTab === "vendors") {
        editVendorData(refreshToken, formData, id)
          .then((response) => {
            if (response?.code === 200 || response?.code === 201) {
              toast.success("Vendor Data updated successfully", {
                className: "text-[12px]",
              });
            } else if (response.code === 400) {
              toast.error(response?.message, {
                className: "text-[12px]",
              });
            } else {
              toast.error(response?.message, {
                className: "text-[12px]",
              });
            }
          })
          .catch((error) => {
            toast.error("Something went wrong!", {
              className: "text-[12px]",
            });
            console.error("Error during login:", error);
          })
          .finally(() => {
            setFormData({
              vendorLegalName: "",
              vendorType: "",
              vendorContactName: "",
              vendorContactEmail: "",
              vendorRegisteredAddress: "",
              vendorContactPhone: "",
              vendorStatus: "",
              vendorOnboardingTimestamp: "",
              vendorOffboardingTimestamp: "",
              reviewer: "",
              questionnaire: [],
            });
            setIsLoadingButton(false);
            setOpen((cur) => !cur);
            setStep(1);
            setReloadData((cur) => !cur);
          });
      } else {
      }
    }
  };

  const handleVendorListSubmit = (e) => {
    e.preventDefault();
    setIsLoadingButton(true);
    assignQuestionnaireToVendor(
      refreshToken,
      { vendorId: [...vendorIdList] },
      assignVendorList?.quesId
    )
      .then((response) => {
        if (response?.code === 200 || response?.code === 201) {
          toast.success("Vendor Assigned successfully", {
            className: "text-[12px]",
          });
        } else if (response.code === 400) {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        } else {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          className: "text-[12px]",
        });
        console.error("Error during login:", error);
      })
      .finally(() => {
        setQuesFormData(quesFormData);
        setIsLoadingButton(false);
        setOpenVendorListDialogQues((cur) => !cur);
        setReloadData((cur) => !cur);
      });
  };

  // End Create Form Functionality

  // start upload vendor list
  const submitVendorList = async (e) => {
    createVendorThroughExcelUpload(refreshToken, excelData)
      .then((response) => {
        if (response?.code === 200 || response?.code === 201) {
          setExcelLogEnteries(response?.logEntries);
          toast.success("Vendors Data created successfully", {
            className: "text-[12px]",
          });
        } else if (response.code === 400) {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        } else {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          className: "text-[12px]",
        });
        console.error("Error during login:", error);
      })
      .finally(() => {
        setIsLoadingButton(false);
        setExcelData([]);
        setExcelError([]);
        setUploadForm({ file: null });
        setReloadData((cur) => !cur);
      });
  };
  // End vendor list

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Vendors Data");

    const headers = [
      "S.No.",
      "vendorLegalName",
      "vendorType",
      "vendorContactName",
      "vendorContactEmail",
      "vendorRegisteredAddress",
      "vendorContactPhone",
      "vendorStatus",
      "vendorOnboardingTimestampe",
      "vendorOffboardingTimestamp",
      "reviewer",
    ];

    worksheet.addRow(headers);

    templateData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.vendorLegalName,
        row.vendorType,
        row.vendorContactName,
        row.vendorContactEmail,
        row.vendorRegisteredAddress,
        row.vendorContactPhone,
        row.vendorStatus,
        row.vendorOnboardingTimestamp,
        row.vendorOffboardingTimestamp,
        row?.reviewer?.fullName,
      ]);
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "vendorManagement_Vendors_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  const exportToExcelQ = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Questionnaire Data");

    const headers = [
      "S.No.",
      "QuestionnaireID",
      "QuestionnaireName",
      "Questionnaire Links",
    ];

    worksheet.addRow(headers);

    templateData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.questionnaireId,
        row?.quesName,
        row?.questionnaireLinks,
      ]);
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "vendorManagement_Questionnaire_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  const sendEmail = (vendorId) => {
    setSendEmailLoading((prev) => ({ ...prev, [vendorId]: true }));
    sendEmailToVendor(refreshToken, vendorId)
      .then((response) => {
        if (response?.code === 200 || response?.code === 201) {
          toast.success("Email sent successfully", {
            className: "text-[12px]",
          });
        } else if (response.code === 400) {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        } else {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          className: "text-[12px]",
        });
        console.error("Error during login:", error);
      })
      .finally(() => {
        // setSendEmailLoading((prev) => ({ ...prev, [vendorId]: false }));
        setSendEmailLoading({});
      });
  };

  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                {activeTab === "vendors"
                  ? "List of Vendor"
                  : activeTab === "questionnaire"
                    ? "List of Questionnaire"
                    : null}
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                {activeTab === "vendors"
                  ? "View all vendors and their compliance against compliance requirements"
                  : activeTab === "questionnaire"
                    ? "View all questionnaire and their compliance against compliance requirements"
                    : null}
              </Typography>
            </div>
            <div className="flex flex-wrap flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              {activeTab === "vendors" ? (
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={exportToExcel}
                  loading={isLoading === null ? true : false}
                >
                  <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={exportToExcelQ}
                  loading={isLoading === null ? true : false}
                >
                  <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
                </Button>
              )}
              {activeTab === "vendors" && rbac?.peopleAdd && (
                <Tooltip
                  className="bg-blue-gray-500"
                  content="Upload vendor's list"
                >
                  <Button
                    onClick={handleOpenUploadDialog}
                    className="flex items-center gap-3"
                    loading={isLoading === null ? true : false}
                    size="sm"
                  >
                    Upload
                  </Button>
                </Tooltip>
              )}
              {activeTab === "vendors" && rbac?.vendorAdd && (
                <Button
                  onClick={handleOpenCreateDialog}
                  className="flex items-center gap-3"
                  loading={isLoading === null ? true : false}
                  size="sm"
                >
                  <UserPlusIcon strokeWidth={2} className="h-4 w-4" />
                  <span className="hidden md:inline-block"> Create New</span>
                </Button>
              )}
              {activeTab === "questionnaire" && rbac?.vendorQuestionnaireAdd && (
                <Button
                  onClick={handleOpenCreateDialogQues}
                  className="flex items-center gap-3"
                  loading={isLoading === null ? true : false}
                  size="sm"
                >
                  <UserPlusIcon strokeWidth={2} className="h-4 w-4" />
                  <span className="hidden md:inline-block"> Create New</span>
                </Button>
              )}
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                label="Select Limit"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                label="Sort By"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
                value={sortBy}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              {/* <Select
                color="green"
                label="Compliance Status"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setCompliantStatus(event);
                  setIsLoading(null);
                }}
                value={compliantStatus}
              >
                <Option value="">All Data</Option>
                <Option value="compliant">Compliant</Option>
                <Option value="nonCompliant">Non Compliant</Option>
              </Select> */}
              <Select
                color="green"
                label="Status"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setStatus(event);
                  setIsLoading(null);
                }}
                value={status}
              >
                <Option value="">All Data</Option>
                <Option value="active">Active</Option>
                <Option value="inactive">Inactive</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                value={searchBy}
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <Tabs id="custom-animation" value={activeTab}>
          <TabsHeader className="mx-4 mt-4">
            {data.map(({ label, value }) => (
              <Tab
                key={value}
                value={value}
                onClick={() => setActiveTab(value)}
                className={activeTab === value ? "text-gray-900" : ""}
              >
                {label}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody
            animate={{
              initial: { y: 250 },
              mount: { y: 0 },
              unmount: { y: 250 },
            }}
          >
            {data.map(({ value, desc }) => (
              <TabPanel key={value} value={value}>
                <CardBody className="px-3 p-0">
                  <table className="mt-4 w-full min-w-max table-auto text-left">
                    <thead>
                      <tr>
                        {tableHead.map((head, index) => (
                          <th
                            key={head}
                            className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-32"
                          >
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                            >
                              {head}{" "}
                              {index !== tableHead.length - 1 && (
                                <ChevronUpDownIcon
                                  strokeWidth={2}
                                  className="h-4 w-4"
                                />
                              )}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    {isLoading === null ? (
                      <>
                        <tbody>
                          <tr>
                            <td colSpan={tableHead.length}>
                              <TableSkeleton />
                            </td>
                          </tr>
                        </tbody>
                      </>
                    ) : activeTab === "vendors" &&
                      templateData &&
                      templateData.length > 0 ? (
                      <tbody>
                        {templateData.map(
                          (
                            {
                              vendorLegalName,
                              vendorType,
                              vendorContactName,
                              vendorContactEmail,
                              vendorContactPhone,
                              vendorRegisteredAddress,
                              vendorStatus,
                              vendorOnboardingTimestamp,
                              vendorOffboardingTimestamp,
                              vendorCompliantStatus,
                              questionnaire,
                              reviewer,
                              id,
                            },
                            index
                          ) => {
                            const questionnaireLength = questionnaire.reduce(
                              (count, { status }) =>
                                status === "assigned" || status === "reAssigned"
                                  ? count
                                  : count - 1,
                              questionnaire.length
                            );
                            const isLast = index === templateData.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";
                            return (
                              <tr key={`${id}-${index}`}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {vendorLegalName}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {vendorType}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <div className="w-max">
                                    <Chip
                                      variant="ghost"
                                      size="sm"
                                      value={vendorStatus}
                                      color={
                                        vendorStatus === "active"
                                          ? "green"
                                          : "red"
                                      }
                                    />
                                  </div>
                                </td>
                                <td className={classes}>
                                  <div className="w-max">
                                    <Chip
                                      variant="ghost"
                                      size="sm"
                                      value={
                                        vendorCompliantStatus === "nonCompliant"
                                          ? "Non-Compliant"
                                          : vendorCompliantStatus
                                      }
                                      color={
                                        vendorCompliantStatus === "compliant"
                                          ? "green"
                                          : vendorCompliantStatus ===
                                            "nonCompliant"
                                            ? "red"
                                            : "orange"
                                      }
                                    />
                                  </div>
                                </td>
                                <td className={classes}>
                                  <Badge
                                    className="text-center"
                                    color={
                                      questionnaire.length > 0 ? "red" : "green"
                                    }
                                    content={
                                      questionnaire.length > 0 ? (
                                        questionnaireLength
                                      ) : (
                                        <span className="text-center">O</span>
                                      )
                                    }
                                    withBorder
                                  >
                                    <Tooltip
                                      content="Questionnaire"
                                      placement="top"
                                    >
                                      <Link
                                        to={`/vendors/response/${id}`}
                                        state={questionnaire}
                                      >
                                        <Button
                                          variant="gradient"
                                          size="sm"
                                          className=" no-underline"
                                        >
                                          {questionnaire.length > 0
                                            ? "Respond"
                                            : "View Response"}
                                        </Button>
                                      </Link>
                                    </Tooltip>
                                  </Badge>
                                </td>
                                <td className={classes}>
                                  <Tooltip
                                    className="bg-blue-gray-500"
                                    content="Send Email"
                                  >
                                    <Button
                                      variant="gradient"
                                      size="sm"
                                      className=" no-underline"
                                      loading={sendEmailLoading[id] || false}
                                      onClick={() => sendEmail(id)}
                                    >
                                      Email
                                    </Button>
                                  </Tooltip>
                                </td>
                                <td className={classes}>
                                  {rbac?.vendorEdit ? (
                                    <>
                                      <Tooltip
                                        className="bg-blue-gray-500"
                                        content="Edit"
                                      >
                                        <IconButton
                                          variant="text"
                                          onClick={() =>
                                            handleOpen({
                                              vendorLegalName,
                                              vendorType,
                                              vendorContactName,
                                              vendorContactEmail,
                                              vendorContactPhone,
                                              vendorRegisteredAddress,
                                              vendorStatus,
                                              vendorOnboardingTimestamp,
                                              vendorOffboardingTimestamp,
                                              questionnaire,
                                              reviewer,
                                              id,
                                            })
                                          }
                                        >
                                          <PencilIcon className="h-4 w-4" />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  ) : null}
                                  {rbac?.vendorDel ? (
                                    <>
                                      <Tooltip
                                        className="bg-blue-gray-500"
                                        content="Delete Record"
                                      >
                                        <IconButton
                                          variant="text"
                                          onClick={() => handleDeleteDialog(id)}
                                        >
                                          <TrashIcon className="h-4 w-4" />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  ) : null}
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    ) : activeTab === "questionnaire" &&
                      quesTemplateData &&
                      quesTemplateData.length > 0 ? (
                      <tbody>
                        {quesTemplateData.map(
                          ({ quesName, quesList, id }, index) => {
                            const isLast = index === templateData.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";
                            return (
                              <tr key={`${id}-${index}`}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal underline cursor-pointer underline-offset-2 hover:text-blue-500"
                                    onClick={() =>
                                      handleQuestionList({
                                        quesName,
                                        quesList,
                                        id,
                                      })
                                    }
                                  >
                                    {quesName}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Button
                                    variant="gradient"
                                    size="sm"
                                    onClick={() =>
                                      handleVendorList({
                                        quesName,
                                        quesList,
                                        id,
                                      })
                                    }
                                  >
                                    Assign Vendor
                                  </Button>
                                </td>
                                <td className={`flex gap-2.5 ${classes}`}>
                                  {rbac?.vendorQuestionnaireDel && <Tooltip
                                    className="bg-blue-gray-500"
                                    content="Delete Questionnaire"
                                  >
                                    <Button
                                      variant="text"
                                      size="md"
                                      className="flex align-items-center text-center"
                                      color="black"
                                      onClick={() => handleDeleteDialog(id)}
                                    >
                                      <TrashIcon className="h-5 w-5" />
                                    </Button>
                                  </Tooltip>}
                                  <Tooltip
                                    className="bg-blue-gray-500"
                                    content="copy questionnaire name"
                                  >
                                    <Button
                                      variant="text"
                                      size="xs"
                                      className="flex align-items-center text-center"
                                      color="black"
                                      onClick={() => {
                                        navigator.clipboard.writeText(quesName);
                                        toast.success("Copied!");
                                      }}
                                    >
                                      <ContentCopyIcon className="h-5 w-5" />
                                    </Button>
                                  </Tooltip>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <div className="flex flex-col items-center w-full">
                            <img
                              quality={100}
                              src="/assets/images/9276430.jpg"
                              className="w-[350px] mix-blend-darken"
                              alt="no-data-found"
                            />
                            <p className="text-[20px] font-medium">
                              No Data Found!
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </table>
                </CardBody>
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page - 1);
                  setIsLoading(null);
                }}
                disabled={totalPage < 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setPage(index + 1);
                      setIsLoading(null);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                ))
                  .reduce((acc, button, index, array) => {
                    if (
                      index < 3 ||
                      index >= totalPage - 3 ||
                      (index >= Math.max(page - 1, 3) &&
                        index <= Math.min(page + 1, totalPage - 4))
                    ) {
                      acc.push(button);
                    } else if (acc[acc.length - 1] !== "ellipsis") {
                      acc.push("ellipsis");
                    }
                    return acc;
                  }, [])
                  .map((element, index, array) => {
                    return element === "ellipsis" ? (
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    ) : index > 0 && array[index - 1] === "ellipsis" ? (
                      <React.Fragment key={`fragment-${index}`}>
                        {element}
                      </React.Fragment>
                    ) : (
                      element
                    );
                  })}
              </div>

              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page + 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )}
      </Card>

      {/* Add Vendor Data  */}
      <Dialog
        size="lg"
        open={openCreateDialog}
        handler={() => setOpenCreateDialog(false)}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Card className="mx-auto w-full p-2">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Add | Vendor Management
              </Typography>
              {step === 1 && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Input
                      type="text"
                      label="Legal Name"
                      size="lg"
                      name="vendorLegalName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorLegalName}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorLegalName && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorLegalName}
                      </p>
                    )}
                  </div>
                  <div>
                    <Select
                      label="Type"
                      onChange={(e) => handleChangeSelect(e, "vendorType")}
                      onBlur={handleBlur}
                      name="vendorType"
                      color="purple"
                      value={formData?.vendorType}
                    >
                      <Option value="active">Select Type</Option>
                      <Option value="consultant">Consultant</Option>
                      <Option value="product">Product</Option>
                      <Option value="manufacturer">Manufacturer</Option>
                    </Select>
                    {errors.vendorType && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorType}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="text"
                      label="Contact Person Name"
                      size="lg"
                      name="vendorContactName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorContactName}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorContactName && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorContactName}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="email"
                      label="Contact Person Email"
                      size="lg"
                      name="vendorContactEmail"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorContactEmail}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorContactEmail && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorContactEmail}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="tel"
                      label="Contact Person Phone"
                      size="lg"
                      name="vendorContactPhone"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorContactPhone}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorContactPhone && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorContactPhone}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="text"
                      label="Registered Address"
                      size="lg"
                      name="vendorRegisteredAddress"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorRegisteredAddress}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorRegisteredAddress && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorRegisteredAddress}
                      </p>
                    )}
                  </div>
                  <div>
                    <Select
                      label="Status"
                      onChange={(e) => handleChangeSelect(e, "vendorStatus")}
                      onBlur={handleBlur}
                      name="vendorStatus"
                      value={formData?.vendorStatus}
                      color="purple"
                    >
                      <Option value="">Select Status</Option>
                      <Option value="active">Active</Option>
                      <Option value="inactive">Inactive</Option>
                    </Select>
                    {errors.vendorStatus && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorStatus}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="date"
                      label="Start Date"
                      name="vendorOnboardingTimestamp"
                      id="vendorOnboardingTimestamp"
                      size="lg"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorOnboardingTimestamp}
                      className="focus:!border-black focus:!border-2 !border-t-0 focus:!border-t-0"
                    />
                    {errors.vendorOnboardingTimestamp && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorOnboardingTimestamp}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="date"
                      label="End Date"
                      name="vendorOffboardingTimestamp"
                      id="vendorOffboardingTimestamp"
                      size="lg"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorOffboardingTimestamp}
                      className="focus:!border-black focus:!border-2 !border-t-0 focus:!border-t-0"
                    />
                    {errors.vendorOffboardingTimestamp && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorOffboardingTimestamp}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {step === 2 && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Assign Questionnaire
                    </Typography>
                    <CreateVendorQuestionnaireList
                      questionnaireList={questionnaireList}
                      isLoadingSelect={vendorIsLoading === null ? true : false}
                      formData={formData}
                      handleChange={handleChangeStep2}
                    />
                  </div>
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Reviewer
                    </Typography>
                    <Select
                      label="Assign Reviewer"
                      color="purple"
                      name="reviewer"
                      onBlur={handleBlur}
                      onChange={(e) => handleChangeSelect(e, "reviewer")}
                      value={formData.reviewer}
                    >
                      {reviewer.map((resp, index) => (
                        <Option key={index} value={resp._id}>
                          {resp.fullName}
                        </Option>
                      ))}
                    </Select>
                    {errors.reviewer && (
                      <p className="text-red-900 text-[12px]">
                        {errors.reviewer}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              {step === 1 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleOpenCreateDialog}
                    className="mr-1"
                  >
                    <span>Cancel</span>
                  </Button>
                  <Button
                    variant="gradient"
                    onClick={handleNext}
                    color="light-blue"
                  >
                    <span>Next</span>
                  </Button>
                </>
              )}
              {step === 2 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handlePrev}
                    className="mr-1"
                  >
                    <span>Back</span>
                  </Button>
                  {isLoadingButton ? (
                    <LoadingButton isSetText={true} isLoading={isLoading} />
                  ) : (
                    <Button variant="gradient" type="submit" color="green">
                      <span>Submit</span>
                    </Button>
                  )}
                </>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>
      {/* End Add Vendor Data  */}

      {/* Edit Vendor Data  */}
      <Dialog
        size="lg"
        open={open}
        handler={handleOpen}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleVendorEdit}>
          <Card className="mx-auto w-full p-2">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Edit | Vendor Information
              </Typography>
              {step === 1 && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Input
                      type="text"
                      label="Legal Name"
                      size="lg"
                      name="vendorLegalName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorLegalName}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorLegalName && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorLegalName}
                      </p>
                    )}
                  </div>
                  <div>
                    <Select
                      label="Type"
                      onChange={(e) => handleChangeSelect(e, "vendorType")}
                      onBlur={handleBlur}
                      name="vendorType"
                      color="purple"
                      value={formData?.vendorType.toLowerCase() || ""}
                    >
                      <Option value="">Select Type</Option>
                      <Option value="consultant">Consultant</Option>
                      <Option value="product">Product</Option>
                      <Option value="manufacturer">Manufacturer</Option>
                    </Select>
                    {errors.vendorType && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorType}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="text"
                      label="Contact Person Name"
                      size="lg"
                      name="vendorContactName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorContactName}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorContactName && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorContactName}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="email"
                      label="Contact Person Email"
                      size="lg"
                      name="vendorContactEmail"
                      onChange={handleChange}
                      value={formData?.vendorContactEmail}
                      onBlur={handleBlur}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorContactEmail && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorContactEmail}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="tel"
                      label="Contact Person Phone"
                      size="lg"
                      name="vendorContactPhone"
                      value={formData?.vendorContactPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorContactPhone && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorContactPhone}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="text"
                      label="Registered Address"
                      size="lg"
                      name="vendorRegisteredAddress"
                      value={formData?.vendorRegisteredAddress}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    />
                    {errors.vendorRegisteredAddress && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorRegisteredAddress}
                      </p>
                    )}
                  </div>
                  <div>
                    <Select
                      label="Status"
                      onChange={(e) => handleChangeSelect(e, "vendorStatus")}
                      onBlur={handleBlur}
                      name="vendorStatus"
                      color="purple"
                      value={formData?.vendorStatus.toLowerCase() || ""}
                    >
                      <Option value="">Select Status</Option>
                      <Option value="active">Active</Option>
                      <Option value="inactive">Inactive</Option>
                    </Select>
                    {errors.vendorStatus && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorStatus}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="date"
                      label="Start Date"
                      name="vendorOnboardingTimestamp"
                      id="vendorOnboardingTimestamp"
                      size="lg"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorOnboardingTimestamp}
                      className="focus:!border-black focus:!border-2 !border-t-0 focus:!border-t-0"
                    />
                    {errors.vendorOnboardingTimestamp && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorOnboardingTimestamp}
                      </p>
                    )}
                  </div>
                  <div>
                    <Input
                      type="date"
                      label="End Date"
                      name="vendorOffboardingTimestamp"
                      id="vendorOffboardingTimestamp"
                      size="lg"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={formData?.vendorOffboardingTimestamp}
                      className="focus:!border-black focus:!border-2 !border-t-0 focus:!border-t-0"
                    />
                    {errors.vendorOffboardingTimestamp && (
                      <p className="text-red-900 text-[12px]">
                        {errors.vendorOffboardingTimestamp}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {step === 2 && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Assign Questionnaire
                    </Typography>
                    <QuestionnaireListVendor
                      questionnaireList={questionnaireList}
                      isLoadingSelect={vendorIsLoading === null ? true : false}
                      formData={defaultQuestionnaireList}
                      handleChange={handleEditChangeStep2}
                    />
                  </div>
                  <div>
                    <Typography className="mb-1" variant="h6">
                      Reviewer
                    </Typography>
                    <Select
                      label="Assign Reviewer"
                      color="purple"
                      name="reviewer"
                      onBlur={handleBlur}
                      onChange={(e) => handleChangeSelect(e, "reviewer")}
                      value={formData.reviewer || ""}
                    >
                      {reviewer.map((resp, index) => (
                        <Option key={index} value={resp._id}>
                          {resp.fullName}
                        </Option>
                      ))}
                    </Select>
                    {errors.reviewer && (
                      <p className="text-red-900 text-[12px]">
                        {errors.reviewer}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              {step === 1 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleEditCancel}
                    className="mr-1"
                  >
                    <span>Cancel</span>
                  </Button>
                  <Button
                    variant="gradient"
                    onClick={handleNext}
                    color="light-blue"
                  >
                    <span>Next</span>
                  </Button>
                </>
              )}
              {step === 2 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handlePrev}
                    className="mr-1"
                  >
                    <span>Back</span>
                  </Button>
                  {isLoadingButton ? (
                    <LoadingButton isSetText={true} isLoading={isLoading} />
                  ) : (
                    <Button variant="gradient" type="submit" color="green">
                      <span>Submit</span>
                    </Button>
                  )}
                </>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>
      {/* End Edit Vendor Data  */}

      {/* Start Delete vendor data */}
      <Dialog
        size="sm"
        open={deleteDialog}
        handler={setDeleteDialog}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <Card className="mx-auto w-full p-2">
          <CardBody className="flex flex-col gap-4">
            <Typography variant="h6 mb-1" color="blue-gray">
              Are you sure you want to delete?
            </Typography>
          </CardBody>
          <CardFooter className="flex justify-end py-2">
            <Button
              variant="text"
              color="red"
              onClick={handleDeleteDialog}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            {isLoadingButton ? (
              <>
                <LoadingButton isSetText={true} isLoading={isLoading} />
              </>
            ) : (
              <Button
                variant="gradient"
                type="submit"
                color="green"
                loading={isLoadingButton}
                onClick={() => handleDelete(deleteDataId)}
              >
                <span>Delete</span>
              </Button>
            )}
          </CardFooter>
        </Card>
      </Dialog>
      {/* End Delete vendor data */}

      {/* Add Questionaare Data  */}
      <Dialog
        size="xl"
        open={openCreateDialogQues}
        handler={() => setOpenCreateDialogQues(false)}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Card className="mx-auto w-full p-2">
            {alertMessage !== "" ? <AlertBox message={alertMessage} /> : ""}
            <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
              <Typography variant="h4" color="blue-gray">
                Add | Vendor Questionnaire
              </Typography>

              <div>
                <Select
                  label="Compliance Standard"
                  onChange={(e) => handleChangeSelect(e, "compliance")}
                  onBlur={handleBlur}
                  name="compliance"
                  color="purple"
                >
                  <Option value="">Select Standard</Option>
                  <Option value="PCI DSS v3.2.1">PCI DSS v3.2.1</Option>
                  <Option value="PCI DSS v4.0">PCI DSS v4.0</Option>
                  <Option value="ISO27001:2013">ISO27001:2013</Option>
                  <Option value="RBI">RBI</Option>
                </Select>
                {errors.compliance && (
                  <p className="text-red-900 text-[12px]">
                    {errors.compliance}
                  </p>
                )}
              </div>
              <div>
                <Input
                  type="text"
                  label="Questionnaire Name"
                  name="quesName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  className="focus:!border-black focus:!border-2 focus:!border-t-0"
                />
                {errors.quesName && (
                  <p className="text-red-900 text-[12px]">{errors.quesName}</p>
                )}
              </div>

              <div>
                <label
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  for="file_input"
                >
                  Upload file
                </label>
                <input
                  className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                  id="file_input"
                  onChange={handleFileUpload}
                  accept=".pdf"
                  name="file"
                  type="file"
                />
                {errors.file && (
                  <p className="text-red-900 text-[12px]">{errors.file}</p>
                )}
              </div>

              <div>
                <Typography className="pb-2" variant="h5" color="blue-gray">
                  User Questions
                </Typography>
                <div>
                  {quesFormData.quesList.map((question, index) => (
                    <div key={index} className="flex items-center gap-4 pb-2">
                      <Textarea
                        size="lg"
                        label={`Question no. - ${index + 1}`}
                        name={`quesList_${index}`}
                        onBlur={handleBlur}
                        onChange={(event) => handleQuestionChange(event, index)}
                        value={question?.question}
                        className="focus:!border-black focus:!border-2 focus:!border-t-0"
                      />
                      <Button
                        variant="outlined"
                        size="sm"
                        color="black"
                        className="flex align-items-center border border-blue-gray-300 p-2"
                        onClick={() => handleDeleteQuestion(index)}
                      >
                        <TrashIcon className="h-5 w-5" />
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-between">
                <Button
                  variant="outlined"
                  size="md"
                  onClick={handleAddQuestion}
                >
                  Add Question
                </Button>
              </div>
              {errors.quesList && (
                <p className="text-red-900 text-[12px]">{errors.quesList}</p>
              )}
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleOpenCreateDialogQues}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              {isLoadingButton ? (
                <>
                  <LoadingButton isSetText={true} isLoading={isLoading} />
                </>
              ) : (
                <Button variant="gradient" type="submit" color="green">
                  <span>Submit</span>
                </Button>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>
      {/* End Questionaare Data  */}

      {/* Assign vendor in Questionnaire tab*/}
      <Dialog
        size="sm"
        open={openVendorListDialogQues}
        handler={setOpenVendorListDialogQues}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleVendorListSubmit}>
          <Card className="mx-auto w-full p-2">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Assign Vendor
              </Typography>
              <div className="grid grid-cols-1">
                <div>
                  <Typography className="mb-1" variant="h6">
                    Select Vendors
                  </Typography>
                  <VendorListQues
                    dropDownVendorData={dropDownVendorData || []}
                    isLoadingSelect={
                      isLoadingSelect === null ? true : isLoadingSelect
                    }
                    assignVendorList={assignVendorList || {}}
                    handleChange={handleChangeVendorList}
                  />
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleVendorList}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              {isLoadingButton ? (
                <>
                  <LoadingButton isSetText={true} isLoading={isLoading} />
                </>
              ) : (
                <Button variant="gradient" type="submit" color="green">
                  <span>Submit</span>
                </Button>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>

      {/* Open Question Modal */}
      <Dialog
        size="lg"
        open={openQuestionModal}
        handler={setOpenQuestionModal}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form>
          <Card className="mx-auto w-full p-2">
            <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
              <Typography variant="h4" color="blue-gray">
                Questionnaire Name: {assignVendorList?.quesName}
              </Typography>
              <div className="grid grid-cols-1">
                <table>
                  <thead>
                    <tr>
                      {["S.no", "List of Questions"].map((head) => (
                        <th
                          key={head}
                          className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                          >
                            {head}{" "}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {assignVendorList?.quesList.map((item, index) => {
                      const isLast = index === assignVendorList.length - 1;
                      const classes = isLast
                        ? "p-4"
                        : "p-4 border-b border-blue-gray-50";
                      return (
                        <tr key={index}>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold"
                            >
                              Question{"-"}
                              {index + 1}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-justify"
                            >
                              {item?.question.length > 40 ? (
                                <TableRowWithShowMore data={item?.question} />
                              ) : (
                                item?.question
                              )}
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button variant="text" color="red" onClick={handleQuestionList}>
                <span>Cancel</span>
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Dialog>

      {/*Excel upload Vendor Modal */}
      <Dialog
        size="md"
        open={openUploadDialog}
        handler={setOpenUploadDialog}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleUploadVendorListSubmit}>
          <Card className="mx-auto w-full p-2">
            {excelLogEnteries.length === 0 ? (
              <>
                <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
                  <Typography variant="h4" color="blue-gray">
                    Upload vendor list
                  </Typography>
                  <div className="grid grid-cols-1">
                    <input
                      className="block p-2 w-full h-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none"
                      id="file_input"
                      onChange={handleVendorFileUpload}
                      accept=".csv, .xlsx, .xls, .xlsm, .xlsb"
                      name="file"
                      type="file"
                    />
                    {errors.file && (
                      <p className="text-red-900 text-[12px]">{errors.file}</p>
                    )}
                    {excelError.length > 0 &&
                      excelError.map((item) => (
                        <p className="text-red-900 text-[12px]">{item}</p>
                      ))}
                  </div>
                  <div
                    className="text-blue-700 !text-xs flex hover:underline hover:underline-offset-1 cursor-pointer"
                    onClick={exportToExcel}
                    loading={isLoading === null ? true : false}
                  >
                    <AttachFileRoundedIcon className="w-1 h-1" />
                    <Typography variant="xs">SampleVendorList</Typography>
                  </div>
                </CardBody>
                <CardFooter className="flex justify-end border-t-2 py-2 gap-4">
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleOpenUploadDialog}
                  >
                    <span>Cancel</span>
                  </Button>
                  {isLoadingButtonForExcel ? (
                    <LoadingButton isSetText={true} isLoading={isLoading} />
                  ) : (
                    <Button variant="gradient" type="submit" color="green">
                      <span>Submit Excel</span>
                    </Button>
                  )}
                </CardFooter>
              </>
            ) : (
              <>
                <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
                  <Typography variant="h4" color="blue-gray">
                    Upload Error
                  </Typography>
                  <table className="mt-1 w-full min-w-max table-auto text-left">
                    <thead>
                      <tr>
                        {["Vendor Name", "Error"].map((head) => (
                          <th
                            key={head}
                            className="cursor-pointer border-y border-red-50 bg-red-50/50 p-2 transition-colors hover:bg-red-50 w-32"
                          >
                            <Typography
                              variant="small"
                              color="black"
                              className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                            >
                              {head}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {excelLogEnteries &&
                        excelLogEnteries.length > 0 &&
                        excelLogEnteries.map((item, index) => {
                          const [vendor1, questionnaire1] = item.split(",");
                          const vendor = vendor1.split(":");
                          const questionnaire = questionnaire1.split(":");
                          const isLast = index === excelLogEnteries.length - 1;
                          const classes = isLast
                            ? "p-2.5"
                            : "p-2.5 border-b border-red-100";
                          return (
                            <tr key={index}>
                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="red"
                                  className="font-normal"
                                >
                                  {vendor[1]}
                                </Typography>
                              </td>
                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="red"
                                  className="font-normal"
                                >
                                  {questionnaire[1]}
                                </Typography>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </CardBody>
                <div className="py-2 bg-red-100 bg-opacity-80 rounded-md p-3">
                  <Typography
                    variant="small"
                    color="red"
                    className="font-normal text-sm"
                  >
                    <span className="font-bold">
                      <sup>*</sup>Error:
                    </span>
                    <span>
                      {" "}
                      Questionnaire not found or spelling error or vendor is
                      already exist.
                    </span>
                  </Typography>
                </div>
                <CardFooter className="flex justify-end border-t-2 py-2">
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleOpenUploadDialog}
                  >
                    <span>Cancel</span>
                  </Button>
                </CardFooter>
              </>
            )}
          </Card>
          <Card className="mx-auto w-full p-2"></Card>
        </form>
      </Dialog>
    </div>
  );
}
